import { useState, useEffect } from 'react';
import { FileText, Mail, CheckCircle2 } from 'lucide-react';
import { getInvoices, resendInvoiceEmail } from '../api/invoices';

export function InvoicesPage() {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sentId, setSentId] = useState(null);

  useEffect(() => {
    getInvoices()
      .then(d => setInvoices(d.invoices || []))
      .finally(() => setLoading(false));
  }, []);

  const handleResend = async (id) => {
    try {
      await resendInvoiceEmail(id);
      setSentId(id);
      setTimeout(() => setSentId(null), 3000);
    } catch (err) {
      // sessiz
    }
  };

  const formatTL = (n) =>
    new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(n);
  const formatDate = (d) => new Date(d).toLocaleDateString('tr-TR');

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <h1 className="text-2xl font-bold text-slate-800 mb-1 flex items-center gap-2">
        <FileText size={24} /> Faturalarım
      </h1>
      <p className="text-slate-500 text-sm mb-8">Geçmiş ödeme ve dekontlarınız</p>

      {loading && <p className="text-slate-500">Yükleniyor...</p>}

      {!loading && invoices.length === 0 && (
        <div className="bg-white rounded-xl border border-slate-200 p-12 text-center">
          <FileText size={48} className="mx-auto text-slate-300 mb-3" />
          <p className="text-slate-500">Henüz faturanız yok</p>
        </div>
      )}

      {!loading && invoices.length > 0 && (
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b border-slate-200">
              <tr>
                <th className="text-left px-4 py-3 text-slate-600 font-semibold">Dekont No</th>
                <th className="text-left px-4 py-3 text-slate-600 font-semibold">Tarih</th>
                <th className="text-left px-4 py-3 text-slate-600 font-semibold">Plan</th>
                <th className="text-right px-4 py-3 text-slate-600 font-semibold">Tutar</th>
                <th className="text-right px-4 py-3 text-slate-600 font-semibold">İşlem</th>
              </tr>
            </thead>
            <tbody>
              {invoices.map(inv => (
                <tr key={inv.id} className="border-b border-slate-100 last:border-0">
                  <td className="px-4 py-3 font-mono text-xs text-slate-700">{inv.invoice_number}</td>
                  <td className="px-4 py-3 text-slate-700">{formatDate(inv.invoice_date)}</td>
                  <td className="px-4 py-3 text-slate-700 capitalize">
                    {inv.plan_name} ({inv.billing_cycle === 'yearly' ? 'Yıllık' : 'Aylık'})
                  </td>
                  <td className="px-4 py-3 text-right font-semibold text-slate-800">
                    {formatTL(inv.total_amount)}
                  </td>
                  <td className="px-4 py-3 text-right">
                    {sentId === inv.id ? (
                      <span className="inline-flex items-center gap-1 text-xs text-green-600">
                        <CheckCircle2 size={14} /> Gönderildi
                      </span>
                    ) : (
                      <button
                        onClick={() => handleResend(inv.id)}
                        className="text-blue-600 hover:underline text-xs inline-flex items-center gap-1"
                      >
                        <Mail size={14} /> Email Gönder
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
